// Base
import Head from 'next/head'
import { GetStaticProps } from 'next'

// Helpers
import { publicFetch } from '@helpers/contentAPI'

// Sections
import DestinationsWrapper from '@sections/destinations/DestinationsWrapper'

export default function Destinations() {
  return (
    <>
      <Head>
        <title>RatePunk Premium | Destinations</title>
        <meta name="description" content="RatePunk Premium" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <main>
        <DestinationsWrapper />
      </main>
    </>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  try {
    const destinations = await publicFetch({
      url: '/api/cities',
      params: {
        'filters[id]': [2409, 1107, 2632, 1035],
        populate: 'image'
      }
    })

    return {
      props: {
        initialReduxState: {
          staticProps: {
            destinations: destinations.data
          }
        }
      }
    }
  } catch {
    return {
      props: {
        initialReduxState: {
          staticProps: {
            destinations: {}
          }
        }
      }
    }
  }
}
